module.exports = __webpack_public_path__ + "img/tz4.4dbd4f00.png";